import * as yup from 'yup';

export const projectCreateValidation = yup.object({
    name: yup.string().required('kindly fill project name.'),
    appName: yup.string().required('kindly fill application name.'),
});
